module.exports = __webpack_public_path__ + "fd5c00b7b6d5f32fc0a2b15c85c7b796.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/VE.svg
// module id = P6Jn
// module chunks = 0